import { render, staticRenderFns } from "./section-oxgen-monitoring-overview.vue?vue&type=template&id=1d05df40&scoped=true"
import script from "./section-oxgen-monitoring-overview.vue?vue&type=script&lang=js"
export * from "./section-oxgen-monitoring-overview.vue?vue&type=script&lang=js"
import style0 from "./section-oxgen-monitoring-overview.vue?vue&type=style&index=0&id=1d05df40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05df40",
  null
  
)

export default component.exports